// 2023/12/27 Leading Win 教育機能対応 DXWEBEDU00100_教育実施状況確認 start
import { Key } from 'react';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import * as Types from 'types';
import { educationStatusList, educationApprovalRegister } from './thunk';
interface InitialState {
  search_info: Types.educationSearchInfo | null;
  education_status_list: Types.EducationStatusInfoType[] | null;
  education_status_count: number | null;
  rKey: Key[] | null;
  loading: boolean;
  error: string;
}
const initialState: InitialState = {
  search_info: null,
  education_status_list: null,
  education_status_count: null,
  rKey: null,
  loading: false,
  error: '',
};
export const educationStatusSlice = createSlice({
  name: 'educationStatus-page',
  initialState,
  reducers: {
    setSearchInfo(state, action: PayloadAction<Types.educationSearchInfo>) {
      if (action.payload) {
        state.search_info = action.payload;
      }
    },
    removeSearchInfo(state) {
      state.search_info = null;
    },
    setRowKey(state, action: PayloadAction<Key[]>) {
      if (action.payload) {
        state.rKey = action.payload;
      }
    },
    removeRowKey(state) {
      state.rKey = null;
    },
    removeError(state) {
      state.error = '';
    },
  },
  extraReducers: (builder) => {
    builder.addCase(educationStatusList.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(educationStatusList.fulfilled, (state, action) => {
      state.education_status_list = action.payload.worker_datas;
      state.education_status_count = action.payload.count;
      state.loading = false;
    });
    builder.addCase(educationStatusList.rejected, (state) => {
      state.loading = false;
    });
    builder.addCase(educationApprovalRegister.pending, (state) => {
      state.loading = false;
    });
    builder.addCase(educationApprovalRegister.fulfilled, (state, action) => {
      state.error = '';
      state.loading = false;
    });
    builder.addCase(educationApprovalRegister.rejected, (state, payload: any) => {
      state.error = payload?.payload?.response?.data?.message || payload.error.message;
      state.loading = false;
    });
  },
});
export const { actions, reducer } = educationStatusSlice;
// 2023/12/27 Leading Win 教育機能対応 DXWEBEDU00100_教育実施状況確認 end
